import { Box, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import GroupsIcon from '@mui/icons-material/Groups';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';

const BG_SECTION    = '#1c1c24';
const BG_CARD       = '#24242e';
const BRAND_RED     = '#c0392b';
const TEXT_PRIMARY  = '#f4f4f6';
const TEXT_SECONDARY = 'rgba(244,244,246,0.65)';
const BORDER_SUBTLE = '1px solid rgba(255,255,255,0.08)';

interface MenuSearchPageProps {
    optionClicked: string | undefined;
    onClickOption: (option: string) => void;
}

const MENU_OPTIONS = [
    { key: 'users',    label: 'Users',    Icon: PersonSearchIcon },
    { key: 'groups',   label: 'Groups',   Icon: GroupsIcon },
    { key: 'projects', label: 'Projects', Icon: LibraryMusicIcon },
];

export default function MenuSearchPage({ optionClicked, onClickOption }: MenuSearchPageProps) {
    return (
        <Box
            sx={{
                bgcolor: BG_SECTION,
                border: BORDER_SUBTLE,
                borderRadius: '10px',
                overflow: 'hidden',
            }}
        >
            <List disablePadding>
                {MENU_OPTIONS.map(({ key, label, Icon }) => {
                    const isSelected = optionClicked === key;
                    return (
                        <ListItemButton
                            key={key}
                            onClick={() => onClickOption(key)}
                            sx={{
                                display: 'flex',
                                flexDirection: { xs: 'row', md: 'row' },
                                justifyContent: { xs: 'center', md: 'flex-start' },
                                borderLeft: {
                                    xs: 'none',
                                    md: isSelected
                                        ? `3px solid ${BRAND_RED}`
                                        : '3px solid transparent',
                                },
                                borderBottom: {
                                    xs: isSelected
                                        ? `3px solid ${BRAND_RED}`
                                        : '3px solid transparent',
                                    md: 'none',
                                },
                                bgcolor: isSelected ? BG_CARD : 'transparent',
                                '&:hover': {
                                    bgcolor: BG_CARD,
                                },
                                py: 1.25,
                                px: 2,
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: { xs: 0, md: 1.5 },
                                    color: isSelected ? TEXT_PRIMARY : TEXT_SECONDARY,
                                }}
                            >
                                <Icon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText
                                primary={label}
                                primaryTypographyProps={{
                                    fontSize: 14,
                                    fontWeight: isSelected ? 700 : 400,
                                    color: isSelected ? TEXT_PRIMARY : TEXT_SECONDARY,
                                    textTransform: 'capitalize',
                                    display: { xs: 'none', md: 'block' },
                                }}
                            />
                        </ListItemButton>
                    );
                })}
            </List>
        </Box>
    );
}
